import React, { useContext, useEffect, useState, useRef } from "react";
import { AppContext } from "../../components/States/AppContext";

//styles
import {
  StandbyBox,
  StandbyLogo,
  StandbyLogoContainer,
  StandbyText,
  StandbyTitle,
} from "./StandbyScreen.elements";

//images
import logo2 from "../../img/misc/logo2.png";

const StandbyScreen = () => {
  const { state, setState } = useContext(AppContext);

  const [remainingTime, setRemainingTime] = useState(0);
  const remainingTimeRef = useRef(remainingTime);

  useEffect(() => {
    let countdownSeconds = 0;

    if (state.standbyTime === "10min") {
      countdownSeconds = 10 * 60;
    } else if (state.standbyTime === "20min") {
      countdownSeconds = 20 * 60;
    } else if (state.standbyTime === "1h") {
      countdownSeconds = 60 * 60;
    } else if (state.standbyTime === "2h") {
      countdownSeconds = 2 * 60 * 60;
    } else if (state.standbyTime === "3h") {
      countdownSeconds = 3 * 60 * 60;
    }

    if (countdownSeconds > 0) {
      countdownSeconds -= 1;
      setRemainingTime(countdownSeconds);
      remainingTimeRef.current = countdownSeconds;

      const countdown = () => {
        if (remainingTimeRef.current > 0) {
          setRemainingTime((prevTime) => prevTime - 1);
          remainingTimeRef.current -= 1;
        }
      };

      const timer = setInterval(countdown, 1000);

      return () => clearInterval(timer);
    }
  }, [state.standbyTime]);

  const hours = Math.floor(remainingTime / 3600);
  const minutes = Math.floor((remainingTime % 3600) / 60);
  const seconds = remainingTime % 60;

  return (
    <StandbyBox>
      <StandbyLogoContainer>
        <StandbyLogo src={logo2} />
      </StandbyLogoContainer>
      <StandbyTitle>Standby</StandbyTitle>
      <StandbyText>
        Monitoring and alarming <br></br> is suspended
      </StandbyText>
      <StandbyText>Touch blue button to resume</StandbyText>
      {["10min", "20min", "1h", "2h", "3h"].includes(state.standbyTime) && (
        <StandbyText>
          {hours < 10 ? `0${hours}` : hours}:
          {minutes < 10 ? `0${minutes}` : minutes}:
          {seconds < 10 ? `0${seconds}` : seconds}
        </StandbyText>
      )}
    </StandbyBox>
  );
};

export default StandbyScreen;
